<template>
  <nav :class="navClassName">
    <p class="sp_menu" @click="openMenu">
      <img src="../../assets/menu.svg" alt="" />
    </p>
    <ul>
      <li>
        <a href="#Outline" v-scroll-to="'#Outline'" @click="closeMenu"
          >イベント概要</a
        >
      </li>
      <li>
        <a href="#Map" v-scroll-to="'#Map'" @click="closeMenu">会場マップ</a>
      </li>
      <li>
        <a href="#Event" v-scroll-to="'#Event'" @click="closeMenu">イベント</a>
      </li>
      <li>
        <a href="#Shop" v-scroll-to="'#Shop'" @click="closeMenu">ショップ</a>
      </li>
      <li>
        <a href="#Staff" v-scroll-to="'#Staff'" @click="closeMenu"
          >スタッフ情報</a
        >
      </li>
    </ul>
    <div class="sp_footer">
      <ul class="sharetext">
        <li class="sharetext_head">SHARE</li>
        <li>
          <button @click="twitterShare(message, siteUrl, hashTag)">
            <img
              src="../../assets/icon_twitter.svg"
              alt="Twitter"
              role="button"
            />
          </button>
        </li>
        <li>
          <button @click="facebookShare(message, siteUrl)">
            <img
              src="../../assets/icon_facebook.svg"
              alt="Facebook"
              role="button"
            />
          </button>
        </li>
        <li>
          <button @click="lineShare(message, siteUrl)">
            <img src="../../assets/icon_line.svg" alt="Twitter" role="button" />
          </button>
        </li>
      </ul>
      <p class="copytext">
        &copy; VirtualCast, Inc. All rights reserved.
      </p>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      message:
        "‪バーチャルキャストでバーチャルマーケット4連動イベント開催！最新のVR内購入機能を先行体験して、魅力的な商品を手にしよう！",
      hashTag: "Vケット4,Vキャス会場",
      siteUrl: "https://corp.virtualcast.jp/vmarket4th",
      isOpen: false
    };
  },
  computed: {
    navClassName: function() {
      return this.isOpen ? "is-open" : "";
    }
  },
  methods: {
    twitterShare: (_msg, _url, _hashtag) => {
      const url =
        `https://twitter.com/intent/tweet?text=` +
        _msg +
        `&url=` +
        _url +
        `&hashtags=` +
        _hashtag;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    },
    facebookShare: (_msg, _url) => {
      const url = `http://www.facebook.com/share.php?u=` + _url + `&t=` + _msg;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    },
    lineShare: (_msg, _url) => {
      const url = `http://line.me/R/msg/text` + _msg + `/?` + _url;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    },
    openMenu: function() {
      this.isOpen = !this.isOpen;
    },
    closeMenu: function() {
      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
nav {
  background: #fff;
  width: 100%;
  margin: -5rem 0 0;
  position: sticky;
  top: 0;
  z-index: 10;
}
nav ul {
  display: flex;
  margin: 0;
  padding: 2rem 0;
  justify-content: center;
  align-items: center;
  list-style: none;
}
nav li {
  padding: 0 1rem;
  margin: 0;
  font-size: 1rem;
  line-height: 1;
  font-weight: bold;
}
nav a {
  color: #707070;
  text-decoration: none;
}
.sp_menu {
  display: none;
}
.sp_footer {
  display: none;
}
@media screen and (max-width: 578px) {
  nav {
    position: fixed;
    margin: 0;
    text-align: left;

    background: none;
    bottom: auto;
  }
  nav.is-open {
    background: rgba(3, 1, 116, 0.75);
    bottom: 0;
  }
  nav ul {
    flex-direction: column;
    align-items: flex-start;
    padding: 78px 0 0;
    display: none;
  }
  nav.is-open ul {
    display: inherit;
  }
  nav a {
    color: #fff;
  }
  .sp_menu {
    display: block;
    position: absolute;
    margin: 0;
    left: 20px;
    top: 20px;
  }
  nav li {
    padding: 0 1rem 1.5rem 2rem;
  }
  .sp_footer {
    position: absolute;
    bottom: 20px;
    left: 20px;
  }
  nav.is-open .sp_footer {
    display: inherit;
  }
  .copytext {
    font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
    font-style: italic;
    font-weight: bold;
    font-size: 12px;
    margin: 0;
    padding: 0;
    color: #fff;
  }
  .sharetext {
    color: #fff;
    margin: 0 0 6px;
    padding: 0;
    align-items: center;
    display: flex;
    list-style: none;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .sharetext_head {
    font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
    font-style: italic;
    font-weight: bold;
    font-size: 12px;
    margin: 1rem 0;
    padding: 1rem 0;
  }
  .sharetext li {
    display: inline-flex;
    align-items: center;
    list-style: none;
    margin: 6px 6px 6px 0;
    padding: 0;
    line-height: 1;
  }
  .sharetext li button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    width: 21px;
    height: 21px;
    cursor: pointer;
  }
  .sharetext li a {
    display: block;
    width: 21px;
    height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TheNavigation.vue